const { isEmpty, } = require('lodash');

const fields = () => {
  return {
    name: {
      type: 'string',
      label: 'タグ名',
      validations: {
        required: v => !isEmpty(v),
      },
    },
  };
};

exports.fields = fields;
